import gql from 'graphql-tag';

export const QUERY_LANDLORD_NAMES = gql`
  query search($query: String, $pageNumber: Int, $pageSize: Int) {
    search(
      query: $query
      pageSize: $pageSize
      pageNumber: $pageNumber
      publishedStatus: PUBLISHED
    ) {
      totalCount
      edges {
        node {
          ... on Landlord {
            type: __typename
            slug
            name
            id
          }
        }
      }
    }
  }
`;
